export default "__VITE_ASSET__86d686bd__"